import React from "react";

const Card = ({ image, title, subtext }) => {
	return (
		<div className="max-w-sm rounded-2xl overflow-hidden shadow-lg bg-white hover:scale-105 transition-transform duration-300">
			<img className="w-full h-48 object-cover" src={image} alt={title} />
			<div className="p-5">
				<h2 className="text-2xl font-bold text-gray-800 mb-2">{title}</h2>
				<p className="text-gray-600">{subtext}</p>
			</div>
		</div>
	);
};

export default Card;
